export const isEmptyValue = (value: any): boolean => {
  return (
    value === undefined ||
    value === null ||
    (typeof value === "string" && value.trim() === "")
  );
};

export const hasAnyEmptyField = (obj: Record<string, any>): boolean => {
  return Object.values(obj).some(isEmptyValue);
};

export const getPlaceholderForEmptyString = (value: string) =>
  value ? value : "-";

export const hasAnyEmptyObject = (obj: Record<string, any>): boolean => {
  return (
    Object?.keys(obj)?.length === 0 || Object?.values(obj)?.some(isEmptyValue)
  );
};
